import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";

function ForgetPassword() {
  const [bgClass, setBgClass] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  const bgClasses = ["bgban2", "bgban3", "bgban4", "bgban5"];

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * bgClasses.length);
    setBgClass(bgClasses[randomIndex]);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);
  
    // Log the data being sent
    console.log("Sending recovery email request with data:", { email });
  
    try {
      const response = await axios.post(`${baseurl}sendRecoveryEmail`, { email });
      setMessage({ type: "success", text: response.data.message || "Recovery email sent!" });
    } catch (error) {
      setMessage({ type: "error", text: error.response?.data?.message || "Something went wrong." });
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <>
      <Navbar />
      <div className={`container-fluid login-container d-flex justify-content-center align-items-center ${bgClass}`}>
        <div className="login-card shadow form-container">
          <h3 className="text-center mb-4">Forgot Password</h3>
          <form onSubmit={handleSubmit}>
            {/* Email Input */}
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email Address</label>
              <input
                type="email"
                className="form-control input-field"
                id="email"
                placeholder="Enter your registered email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {/* Submit Button */}
            <button type="submit" className="btn btn-primary w-100 login-btn" disabled={loading}>
              {loading ? "Sending..." : "Send Recovery Email"}
            </button>

            {/* Message */}
            {message && (
              <div className={`mt-3 text-center text-${message.type === "success" ? "success" : "danger"}`}>
                {message.text}
              </div>
            )}

            {/* Back to Login Link */}
            <div className="mt-3 text-center">
              <Link to="/login" className="forgot-link">Back to Login</Link>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default ForgetPassword;
